import React from "react";
import ReactDOM from "react-dom/client";
import { Buffer } from "buffer";
import "@/index.css";
import App from "@/App";

// Polyfill Buffer for browser (required by @react-pdf/renderer, which
// depends on Node's Buffer to build the PDF blob).
if (typeof window !== "undefined" && !window.Buffer) {
    window.Buffer = Buffer;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
